import { useCallback, useContext } from "react";
import { CurrentUserContext } from "../App.web";

export const useUserIDToken = () => {
  const currentUser = useContext(CurrentUserContext);

  return useCallback(async () => {
    if (!currentUser?.user) {
      return;
    }

    const idToken = await currentUser.user.getIdToken();

    return idToken;
  }, [currentUser]);
};
